module.exports = __webpack_public_path__ + "static/media/under25_logo.ca1afe02.png";